import { defineStore } from 'pinia'
import axios from '../services/index.js'

export const useBillingStore = defineStore('billing', {
  state: () => ({
    pendingInvoices: [],
    paidInvoices: [],
    credits: [],
    hasOverdue: false,
    currentUsage: null,
    estimate: null,
    loading: false,
    loadingUsage: false,
  }),

  getters: {
    firstPendingInvoice: (state) => state.pendingInvoices[0] || null,
  },

  actions: {
    async fetchBilling() {
      this.loading = true
      try {
        const response = await axios.get('/api/billing')
        this.pendingInvoices = response.data.pending_invoices || []
        this.paidInvoices = response.data.paid_invoices || []
        this.credits = response.data.credits || []
        this.hasOverdue = response.data.has_overdue || false
      } catch (error) {
        console.error('Error fetching billing:', error)
      } finally {
        this.loading = false
      }
    },

    async fetchUsage() {
      this.loadingUsage = true
      try {
        const response = await axios.get('/api/billing/usage')
        this.currentUsage = response.data.current || null
        this.estimate = response.data.estimated || null
      } catch (error) {
        console.error('Error fetching usage:', error)
      } finally {
        this.loadingUsage = false
      }
    },

    async applyCoupon(code, invoiceId) {
      try {
        const response = await axios.post('/api/billing/apply-coupon', {
          code,
          invoice_id: invoiceId,
        })
        // Refrescar billing para ver el descuento aplicado
        await this.fetchBilling()
        return response.data
      } catch (error) {
        throw error.response?.data || error
      }
    },
  }
})
